// import React, { useEffect, useMemo } from "react";
// import { Link } from "react-router-dom";
// import { FaRegClipboard } from "react-icons/fa";

// import Table from "../../components/Table/Table";
// import Loader from "../../components/Loader/Loader";
// import Pagination from "../../components/Pagination/Pagination";
// import CardHeader from "../../components/Card/CardHeader";

// import { getFileFromS3 } from "../../utils/getFileFromS3";
// import { tableConstants } from "./HomeworkTableConst";

// import HomeworkFilter from "./HomeworkFilter";
// import { useHomeworks } from "./hooks/useHomeworks";
// import { useTeacherPrograms } from "../../hooks/useTeacherPrograms";

// const HomeworkList = () => {
//   const permissions = useMemo(
//     () => JSON.parse(localStorage.getItem("permissions")) || [],
//     []
//   );

//   const { programData } = useTeacherPrograms();

//   const {
//     homeworkList,
//     filters,
//     isHomeworkLoading,
//     lastPage,
//     currentPage,
//     fetchHomeworks,
//     deleteHomeworkById,
//     handleFilterChange,
//     handleSearch,
//     handleReset,
//     handlePageChange, // ✅ use hook pagination
//   } = useHomeworks();

//   useEffect(() => {
//     fetchHomeworks(1);
//   }, [fetchHomeworks]);

//   const handleDownload = async (path) => {
//     await getFileFromS3(path, true);
//   };

//   return (
//     <div className="card">
//       <CardHeader
//         title="Homeworks"
//         icon={<FaRegClipboard />}
//         button={
//           permissions.includes("homework.assign") && (
//             <Link className="btn btn-primary" to="/homework/create">
//               Add Homework
//             </Link>
//           )
//         }
//       />

//       <div className="card-body">
//         <HomeworkFilter
//           programData={programData}
//           filters={filters}
//           onFilterChange={handleFilterChange}
//           onSearch={handleSearch}
//           onReset={handleReset}
//         />

//         {isHomeworkLoading && <Loader />}

//         <div className="evaluating-table event-tablecus">
//           <Table
//             cols={tableConstants(
//               deleteHomeworkById,
//               permissions,
//               handleDownload
//             )}
//             data={homeworkList}
//             hoverable
//             striped
//           />
//         </div>

//         {lastPage > 1 && (
//           <Pagination
//             totalPage={lastPage}
//             currentPage={currentPage}
//             handlePageChange={handlePageChange} // ✅ FIXED
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default HomeworkList;

import React, { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { FaRegClipboard } from "react-icons/fa";

import Table from "../../components/Table/Table";
import Loader from "../../components/Loader/Loader";
import Pagination from "../../components/Pagination/Pagination";
import CardHeader from "../../components/Card/CardHeader";

import { getFileFromS3 } from "../../utils/getFileFromS3";
import { tableConstants } from "./HomeworkTableConst";

import HomeworkFilter from "./HomeworkFilter";
import { useHomeworks } from "./hooks/useHomeworks";
import { useTeacherPrograms } from "../../hooks/useTeacherPrograms";

const HomeworkList = () => {
  const permissions = useMemo(
    () => JSON.parse(localStorage.getItem("permissions")) || [],
    []
  );

  const { programData } = useTeacherPrograms();

  const {
    homeworkList,
    filters,
    isHomeworkLoading,
    lastPage,
    currentPage,
    fetchHomeworks,
    deleteHomeworkById,
    handleFilterChange,
    handleSearch,
    handleReset,
    handlePageChange,
  } = useHomeworks();

  // ✅ CALL API ONLY ONCE (NO DEPENDENCY LOOP)
  useEffect(() => {
    fetchHomeworks(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDownload = async (path) => {
    await getFileFromS3(path, true);
  };

  return (
    <div className="card">
      <CardHeader
        title="Homeworks"
        icon={<FaRegClipboard />}
        button={
          permissions.includes("homework.assign") && (
            <Link className="btn btn-primary" to="/homework/create">
              Add Homework
            </Link>
          )
        }
      />

      <div className="card-body">
        <HomeworkFilter
          programData={programData}
          filters={filters}
          onFilterChange={handleFilterChange}
          onSearch={handleSearch}
          onReset={handleReset}
        />

        {isHomeworkLoading && <Loader />}

        <div className="evaluating-table event-tablecus">
          <Table
            cols={tableConstants(
              deleteHomeworkById,
              permissions,
              handleDownload
            )}
            data={homeworkList}
            hoverable
            striped
          />
        </div>

        {lastPage > 1 && (
          <Pagination
            totalPage={lastPage}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
          />
        )}
      </div>
    </div>
  );
};

export default HomeworkList;


